<template>
    <Transition name="fade">
        <router-link :to="url"  :class="kind" v-if="ready && main && main.backdrop_path">
            <div class="contentGuide" v-if="ready && main && main.backdrop_path" ref="bg">
                <div class="media" >

                    <img :src="main.backdrop_path" class="splash"/>

                    <div class="logo">
                        <img :src="guide.asset.img" loading="lazy" />
                    </div>
                </div>
                <p> {{ guide.name }} </p>
                <span> {{title}} </span>
            </div>
        </router-link>
    </Transition>
</template>

<script>
export default {
  name: 'guide',

  props: {
      guide: Object,
      kind: {
        type: String,
        default: () => {return ''}
      }
  },

  components: {
  },

  computed: {
        url(){
            if(this.isDesktop){
                return `/theater?mode=epg&id=${this.guide.key}`
            }else{
                return '/guide/' + this.guide.key
            }
        }
  },

  data: function(){
    return {
        title: '',
        ready: false,
        main: {backdrop_path: ''},
    }
  },

  methods: {

        nowplaying(items) {
            const currentTime = window.now;

            for (const item of items) {
                const startTime = new Date(item.start).getTime();
                const endTime = new Date(item.end).getTime();

                if (currentTime >= startTime && currentTime <= endTime) {
                    return item;
                }
            }

            return null;
        }

  },

  mounted: async function(){
    const now = this.nowplaying(this.guide.schedule)
    if(now){
        this.title = now.name
        const response  = await window.afetch(`/searchVod?query=${this.title}`)
        const data =  await response.json()
        this.main = data.results[0]

        this.$nextTick(() => {
            this.ready = true
            this.$nextTick(() => {
                if(this.guide.asset && this.$refs.bg){
                    this.$refs.bg.style.background = window.getAssetColor(this.guide.asset)
                }
            })
        })
    }
  }
}
</script>

<style scoped lang="scss">
.contentGuide{
    display: flex;
    flex-direction: column;
    width: 60vw;
    max-width: 275px;
    position: relative;
    background-color: black;
    border-radius: 5px;
    margin-right: 10px;
    min-height: 175px;
    span{
        color: white;
        text-transform: uppercase;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        margin: 0;
        padding: 10px 0;
        padding-left: 10px;
        max-width: 95%;
        font-size: 12px;
    }
    p{
        padding: 0;
        padding-top: 10px;
        padding-left: 10px;
        font-size: 7px;
        margin: 0;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: white;
        font-weight: bold;

    }
    .media{
        height: 120px;
        overflow: hidden;
        border-radius: 5px;
        position: relative;
        width: 100%;
    }
    .splash{
        width: 100%;
        min-height: 100%;
        object-fit: cover;
        position: absolute;
    }
    .logo{
        position: absolute;
        z-index: 2;
        background-color: white;
        border-radius: 5px;
        height: 30px;
        padding: 10px;
        display: flex;
        align-items: center;
        img{
            width: 30px;
        }
    }
}
</style>
